import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _parseFloat from "@babel/runtime-corejs2/core-js/parse-float";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { polyfill } from 'react-lifecycles-compat';
import createRef from '@roo/create-react-ref/createRef';
import { add, sub, mul, div } from './util';
var DEFAULT_MAX = 100;
var DEFAULT_MIN = 0;
var DEFAULT_STEP = 1;
var DEFAULT_VALUE = 0;
var INDEX_EN = ['One', 'Two'];

var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);

  var _super = _createSuper(Slider);

  function Slider() {
    var _this;

    _classCallCheck(this, Slider);

    _this = _super.apply(this, arguments);
    _this.state = {
      currentPositionOne: '',
      currentPositionTwo: '',
      valueOne: 0,
      valueTwo: 0,
      oldValueOne: 0,
      oldValueTwo: 0,
      draggingOne: false,
      hoveringOne: false,
      draggingTwo: false,
      hoveringTwo: false,
      prevProps: {}
    };
    _this.sliderBarRef = createRef();
    _this.button1Ref = createRef();
    _this.button2Ref = createRef();
    _this.num = 1;
    _this.startPos = 0;
    _this.newPos = 0;
    _this.startX = 0;

    _this.handleClick = function (e) {
      var _this$state = _this.state,
          draggingOne = _this$state.draggingOne,
          draggingTwo = _this$state.draggingTwo;
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          range = _this$props.range;
      if (draggingOne || draggingTwo || disabled) return;

      var sliderBarOffsetLeft = _this.sliderBarRef && _this.sliderBarRef.current.getBoundingClientRect().left;

      var value = _this.getValue(mul(div(sub(e.clientX, sliderBarOffsetLeft), _this.sliderBarWidth), 100));

      var position = _this.getPosition(value);

      if (!range) {
        _this.setState({
          valueOne: value,
          currentPositionOne: position
        }, function () {
          _this.setValue();
        });

        return;
      }

      var button1Left = _this.button1Ref && _this.button1Ref.current.getBoundingClientRect().left;

      var button2Left = _this.button2Ref && _this.button2Ref.current.getBoundingClientRect().left;

      if (Math.abs(e.clientX - button1Left) < Math.abs(e.clientX - button2Left)) {
        _this.setState({
          valueOne: value,
          currentPositionOne: position
        }, function () {
          _this.setValue();
        });
      } else {
        _this.setState({
          valueTwo: value,
          currentPositionTwo: position
        }, function () {
          _this.setValue();
        });
      }
    };

    _this.handleButtonDown = function (num, e) {
      e.preventDefault();
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.num = num;

        _this.handleDragStart(e);

        window.addEventListener('mousemove', _this.handleDragging);
        window.addEventListener('mouseup', _this.handleDragEnd);
        window.addEventListener('contextmenu', _this.handleDragEnd);
      }
    };

    _this.handleDragStart = function (e) {
      var startX = e.clientX;
      var index = INDEX_EN[_this.num]; // @ts-ignore

      var currentPosition = _this.state["currentPosition".concat(index)];

      var startPos = _parseFloat(currentPosition);

      _this.startPos = startPos;
      _this.newPos = startPos;
      _this.startX = startX; // @ts-ignore

      _this.setState(_defineProperty({}, "dragging".concat(index), true), function () {
        _this.setValue();
      });
    };

    _this.handleDragging = function (e) {
      var index = INDEX_EN[_this.num]; // @ts-ignore

      if (_this.state["dragging".concat(index)]) {
        var _this$setState2;

        var _assertThisInitialize = _assertThisInitialized(_this),
            startPos = _assertThisInitialize.startPos,
            startX = _assertThisInitialize.startX;

        var currentX = e.clientX;
        var diff = (currentX - startX) / _this.sliderBarWidth * 100;
        var newPos = startPos + diff;

        var value = _this.getValue(newPos);

        var position = _this.getPosition(value);

        _this.newPos = newPos;

        _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, "value".concat(index), value), _defineProperty(_this$setState2, "currentPosition".concat(index), position), _this$setState2), function () {
          _this.setValue();
        });
      }
    };

    _this.handleDragEnd = function () {
      var index = INDEX_EN[_this.num]; // @ts-ignore

      if (_this.state["dragging".concat(index)]) {
        var _this$setState3;

        var _assertThisInitialize2 = _assertThisInitialized(_this),
            newPos = _assertThisInitialize2.newPos;

        var value = _this.getValue(newPos);

        var position = _this.getPosition(value);

        _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, "value".concat(index), value), _defineProperty(_this$setState3, "currentPosition".concat(index), position), _defineProperty(_this$setState3, "dragging".concat(index), false), _this$setState3), function () {
          _this.setValue();
        });

        window.removeEventListener('mousemove', _this.handleDragging);
        window.removeEventListener('mouseup', _this.handleDragEnd);
        window.removeEventListener('contextmenu', _this.handleDragEnd);
      }
    };

    _this.handleMouseEnter1 = function () {
      _this.setState({
        hoveringOne: true
      });
    };

    _this.handleMouseLeave1 = function () {
      _this.setState({
        hoveringOne: false
      });
    };

    _this.handleMouseEnter2 = function () {
      _this.setState({
        hoveringTwo: true
      });
    };

    _this.handleMouseLeave2 = function () {
      _this.setState({
        hoveringTwo: false
      });
    };

    return _this;
  }

  _createClass(Slider, [{
    key: "getValue",
    value: function getValue(newPos) {
      if (newPos < 0) {
        newPos = 0;
      } else if (newPos > 100) {
        newPos = 100;
      }

      var _this$props2 = this.props,
          _this$props2$max = _this$props2.max,
          max = _this$props2$max === void 0 ? DEFAULT_MAX : _this$props2$max,
          _this$props2$min = _this$props2.min,
          min = _this$props2$min === void 0 ? DEFAULT_MIN : _this$props2$min,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? DEFAULT_STEP : _this$props2$step;
      var lengthPerStep = div(100, div(sub(max, min), step));
      var steps = Math.round(div(newPos, lengthPerStep));
      return _parseFloat("".concat(add(mul(steps, step), min)));
    }
  }, {
    key: "setValue",
    value: function setValue() {
      var _this$props3 = this.props,
          range = _this$props3.range,
          onChange = _this$props3.onChange;
      var _this$state2 = this.state,
          valueOne = _this$state2.valueOne,
          valueTwo = _this$state2.valueTwo;
      var _this$state3 = this.state,
          oldValueOne = _this$state3.oldValueOne,
          oldValueTwo = _this$state3.oldValueTwo;

      if (!range) {
        if (oldValueOne !== valueOne) {
          oldValueOne = valueOne;

          if (onChange && typeof onChange === 'function') {
            onChange(valueOne);
          }
        }
      } else {
        if (oldValueOne !== valueOne || oldValueTwo !== valueTwo) {
          var arr = [Math.min(valueOne, valueTwo), Math.max(valueOne, valueTwo)];
          oldValueOne = valueOne;
          oldValueTwo = valueTwo;

          if (onChange && typeof onChange === 'function') {
            onChange(arr);
          }
        }
      }

      this.setState({
        oldValueOne: oldValueOne,
        oldValueTwo: oldValueTwo
      });
    }
  }, {
    key: "getPosition",
    value: function getPosition(value) {
      var _this$props4 = this.props,
          _this$props4$min = _this$props4.min,
          min = _this$props4$min === void 0 ? DEFAULT_MIN : _this$props4$min,
          _this$props4$max = _this$props4.max,
          max = _this$props4$max === void 0 ? DEFAULT_MIN : _this$props4$max;
      return max - min === 0 ? '0%' : "".concat((value - min) / (max - min) * 100, "%");
    }
  }, {
    key: "renderStops",
    value: function renderStops() {
      var stops = this.stops;
      var arr = stops.map(function (stop, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "roo-slider-stop-".concat(index),
          style: {
            left: "".concat(stop, "%")
          },
          className: "roo-slider-bar-stop"
        });
      });
      return arr;
    }
  }, {
    key: "renderLabels",
    value: function renderLabels() {
      var labelRenderer = this.props.labelRenderer;
      var values = this.values,
          allLabels = this.allLabels;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-slider-labels"
      }, labelRenderer && values.map(function (val, index) {
        var cusLabelNode = labelRenderer(val.value);

        if (cusLabelNode) {
          var style = cusLabelNode.props.style;
          style = style || {};
          style.left = val.left;
          return /*#__PURE__*/React.cloneElement(cusLabelNode, {
            style: style,
            key: "roo-slider-label-".concat(index),
            className: 'roo-slider-label'
          });
        }

        return null;
      }), !labelRenderer && allLabels.map(function (label, index) {
        return /*#__PURE__*/React.createElement("span", {
          key: "roo-slider-label-".concat(index),
          style: _Object$assign({
            left: "".concat(label.left)
          }, label.style),
          className: "roo-slider-label"
        }, label.label);
      }));
    }
  }, {
    key: "renderToolTip",
    value: function renderToolTip(index) {
      // @ts-ignore
      var hovering = this.state["hovering".concat(INDEX_EN[index])]; // @ts-ignore

      var dragging = this.state["dragging".concat(INDEX_EN[index])]; // @ts-ignore

      var value = this.state["value".concat(INDEX_EN[index])];
      var _this$props5 = this.props,
          popupClassName = _this$props5.popupClassName,
          popupStyle = _this$props5.popupStyle;

      if (hovering || dragging) {
        return /*#__PURE__*/React.createElement("div", {
          className: classNames('roo-tooltip roo-tooltip-sm roo-tooltip-top', popupClassName),
          style: _Object$assign({
            position: 'absolute',
            bottom: '26px'
          }, popupStyle)
        }, /*#__PURE__*/React.createElement("div", {
          className: "roo-tooltip-arrow"
        }), /*#__PURE__*/React.createElement("div", {
          className: "roo-tooltip-inner"
        }, value));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          disabled = _this$props6.disabled,
          range = _this$props6.range,
          showStops = _this$props6.showStops,
          showLabels = _this$props6.showLabels,
          className = _this$props6.className,
          style = _this$props6.style;
      var _this$state4 = this.state,
          currentPositionOne = _this$state4.currentPositionOne,
          currentPositionTwo = _this$state4.currentPositionTwo,
          hoveringOne = _this$state4.hoveringOne,
          draggingOne = _this$state4.draggingOne,
          hoveringTwo = _this$state4.hoveringTwo,
          draggingTwo = _this$state4.draggingTwo;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-slider', className),
        style: style
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-slider-bar', {
          'roo-slider-bar-disabled': disabled
        }),
        onClick: this.handleClick,
        ref: this.sliderBarRef
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-slider-value-bar', {
          'roo-slider-value-bar-disabled': disabled
        }),
        style: {
          left: this.valueBarLeft,
          width: this.valueBarWidth
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-slider-button-wrap', {
          'roo-slider-tool-tips': draggingOne || hoveringOne,
          'roo-slider-button-wrap-grabbing': draggingOne
        }),
        style: {
          left: currentPositionOne
        },
        ref: this.button1Ref,
        onMouseDown: function onMouseDown(e) {
          return _this2.handleButtonDown(0, e);
        },
        onMouseEnter: this.handleMouseEnter1,
        onMouseLeave: this.handleMouseLeave1
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-slider-button', {
          'roo-slider-button-dragging': draggingOne,
          'roo-slider-button-hovering': hoveringOne,
          'roo-slider-button-disabled': disabled
        })
      }), this.renderToolTip(0)), range && /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-slider-button-wrap', {
          'roo-slider-tool-tips': draggingTwo || hoveringTwo,
          'roo-slider-button-wrap-grabbing': draggingTwo
        }),
        style: {
          left: "".concat(currentPositionTwo)
        },
        ref: this.button2Ref,
        onMouseDown: function onMouseDown(e) {
          return _this2.handleButtonDown(1, e);
        },
        onMouseEnter: this.handleMouseEnter2,
        onMouseLeave: this.handleMouseLeave2
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames('roo-slider-button', {
          'roo-slider-button-dragging': draggingTwo,
          'roo-slider-button-hovering': hoveringTwo,
          'roo-slider-button-disabled': disabled
        })
      }), this.renderToolTip(1)), showStops && this.renderStops(), showLabels && this.renderLabels()));
    }
  }, {
    key: "valueBarWidth",
    get: function get() {
      var range = this.props.range;
      var _this$state5 = this.state,
          currentPositionOne = _this$state5.currentPositionOne,
          currentPositionTwo = _this$state5.currentPositionTwo;
      return range ? "".concat(Math.abs(_parseFloat(currentPositionOne) - _parseFloat(currentPositionTwo)), "%") : currentPositionOne;
    }
  }, {
    key: "valueBarLeft",
    get: function get() {
      var range = this.props.range;
      var _this$state6 = this.state,
          currentPositionOne = _this$state6.currentPositionOne,
          currentPositionTwo = _this$state6.currentPositionTwo;

      if (!range) {
        return '0';
      } else {
        return _parseFloat(currentPositionOne) > _parseFloat(currentPositionTwo) ? currentPositionTwo : currentPositionOne;
      }
    }
  }, {
    key: "stops",
    get: function get() {
      var _this$props7 = this.props,
          _this$props7$step = _this$props7.step,
          step = _this$props7$step === void 0 ? DEFAULT_STEP : _this$props7$step,
          _this$props7$max = _this$props7.max,
          max = _this$props7$max === void 0 ? DEFAULT_MAX : _this$props7$max,
          _this$props7$min = _this$props7.min,
          min = _this$props7$min === void 0 ? DEFAULT_MIN : _this$props7$min,
          range = _this$props7.range;
      var _this$state7 = this.state,
          valueOne = _this$state7.valueOne,
          valueTwo = _this$state7.valueTwo;
      var diff = max - min;
      var stopCount = diff / step;
      var stepWidth = 100 * step / diff;
      var result = [];

      for (var i = 1; i < stopCount; i++) {
        result.push(i * stepWidth);
      }

      if (range) {
        return result.filter(function (st) {
          return _parseFloat("".concat(st)) < _parseFloat("".concat(100 * (Math.min(valueOne, valueTwo) - min) / diff)) || _parseFloat("".concat(st)) > _parseFloat("".concat(100 * (Math.max(valueOne, valueTwo) - min) / diff));
        });
      } else {
        return result.filter(function (st) {
          return _parseFloat("".concat(st)) > _parseFloat("".concat(100 * (valueOne - min) / diff));
        });
      }
    }
  }, {
    key: "sliderBarWidth",
    get: function get() {
      return _parseFloat("".concat(document.defaultView.getComputedStyle(this.sliderBarRef.current).width));
    }
  }, {
    key: "values",
    get: function get() {
      var _this$props8 = this.props,
          _this$props8$max = _this$props8.max,
          max = _this$props8$max === void 0 ? DEFAULT_MAX : _this$props8$max,
          _this$props8$min = _this$props8.min,
          min = _this$props8$min === void 0 ? DEFAULT_MIN : _this$props8$min,
          _this$props8$step = _this$props8.step,
          step = _this$props8$step === void 0 ? DEFAULT_STEP : _this$props8$step;
      var diff = max - min;
      var values = [];

      for (var value = min; value <= max; value += step) {
        values.push({
          value: value,
          left: "".concat((value - min) / diff * 100, "%")
        });
      }

      return values;
    }
  }, {
    key: "allLabels",
    get: function get() {
      var _this$props9 = this.props,
          labels = _this$props9.labels,
          _this$props9$max = _this$props9.max,
          max = _this$props9$max === void 0 ? DEFAULT_MAX : _this$props9$max,
          _this$props9$min = _this$props9.min,
          min = _this$props9$min === void 0 ? DEFAULT_MIN : _this$props9$min;

      if (!labels) {
        return this.values.map(function (_ref) {
          var value = _ref.value,
              left = _ref.left;
          return {
            label: value,
            left: left
          };
        });
      }

      return _Object$keys(labels).map(function (key) {
        var diff = max - min;
        var value = Number(key);
        var labelConfig = labels[key];
        var label = labelConfig && (typeof labelConfig === 'string' ? labelConfig : labelConfig.label);
        var style = labelConfig && labelConfig.style;
        return {
          left: "".concat((value - min) / diff * 100, "%"),
          label: label,
          style: style
        };
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var prevProps = prevState.prevProps;

      if (nextProps.value !== prevProps.value || nextProps.max !== prevProps.max || nextProps.min !== prevProps.min || nextProps.step !== prevProps.step || nextProps.showStops !== prevProps.showStops || nextProps.showLabels !== prevProps.showLabels || nextProps.labels !== prevProps.labels || nextProps.range !== prevProps.range || nextProps.disabled !== prevProps.disabled) {
        var _nextProps$max = nextProps.max,
            max = _nextProps$max === void 0 ? DEFAULT_MAX : _nextProps$max,
            _nextProps$min = nextProps.min,
            min = _nextProps$min === void 0 ? DEFAULT_MIN : _nextProps$min,
            value = nextProps.value,
            range = nextProps.range;
        var diff = max - min;

        var getValue = function getValue(val) {
          return Math.max(Math.min(val, max), min);
        };

        var valueOne = range ? getValue(_Array$isArray(value) ? value[0] : DEFAULT_MIN) : getValue(value || 0);
        var valueTwo = range ? getValue(_Array$isArray(value) ? value[1] : DEFAULT_MAX) : '';
        var currentPositionOne = diff === 0 ? '0%' : "".concat((valueOne - min) / diff * 100, "%"); // eslint-disable-next-line

        var currentPositionTwo = diff === 0 ? '0%' : range ? "".concat((valueTwo - min) / diff * 100, "%") : '';
        var oldValueOne = valueOne;
        var oldValueTwo = range ? valueTwo : '';
        return {
          valueOne: valueOne,
          valueTwo: valueTwo,
          oldValueOne: oldValueOne,
          oldValueTwo: oldValueTwo,
          currentPositionOne: currentPositionOne,
          currentPositionTwo: currentPositionTwo,
          prevProps: nextProps
        };
      }

      return null;
    }
  }]);

  return Slider;
}(React.Component);

Slider.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  showStops: PropTypes.bool,
  showLabels: PropTypes.bool,
  labels: PropTypes.object,
  range: PropTypes.bool,
  disabled: PropTypes.bool,
  labelRenderer: PropTypes.func,
  onChange: PropTypes.func,
  popupStyle: PropTypes.object
};
Slider.defaultProps = {
  value: DEFAULT_VALUE,
  max: DEFAULT_MAX,
  min: DEFAULT_MIN,
  step: DEFAULT_STEP,
  showStops: false,
  showLabels: false,
  labels: undefined,
  range: false,
  disabled: false,
  onChange: undefined,
  labelRenderer: undefined,
  popupStyle: {}
};
polyfill(Slider);
export default Slider;